import { GET_SUPPORT_SUMMARY, GET_SUPPORT_SUMMARY_SUCCESS, GET_SUPPORT_SUMMARY_ERROR, GET_SUPPORT_SUMMARY_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSupportSummary = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPORT_SUMMARY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SUPPORT_SUMMARY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SUPPORT_SUMMARY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SUPPORT_SUMMARY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSupportSummary;
